import React from "react";
import { cn } from "../../../lib/cn";

/**
 * ProgressBar — ui-v2.5. Avance porcentual con color POR UMBRAL (no fijo).
 * Especificación: ui-v2.5-catalogo-componentes.html · sección ProgressBar.
 *
 * Umbrales: 0–40% warn (#f59e0b) · 41–75% brand-600 (#0066b3) · 76–100% ok (#10b981).
 * Relleno con transición .3s en el ancho. Variante `onDark` para cabecera de Drawer.
 *
 * <ProgressBar value={60} />                          // umbral automático
 * <ProgressBar value={2} max={3} label="2/3 acusados" />
 * <ProgressBar value={60} label="60% onboarding" onDark />
 *  - tone opcional fuerza el color: "warn" | "brand" | "ok".
 *  - label: nodo a la derecha (min 36px para que los % no bailen entre filas).
 */

const toneFill = { warn: "bg-v25-warn", brand: "bg-v25-brand-600", ok: "bg-v25-ok" };

export function ProgressBar({ value = 0, max = 100, label, tone, onDark = false, className }) {
  const pct = max > 0 ? Math.min(100, Math.max(0, (value / max) * 100)) : 0;
  const fill = onDark
    ? "bg-emerald-400" // #34d399, relleno sobre oscuro
    : tone
    ? toneFill[tone]
    : pct <= 40
    ? "bg-v25-warn"
    : pct <= 75
    ? "bg-v25-brand-600"
    : "bg-v25-ok";

  return (
    <div className={cn("flex items-center gap-2", className)}>
      <div className={cn("h-1.5 flex-1 overflow-hidden rounded-v25-full", onDark ? "bg-white/20" : "bg-v25-surface-raised")}>
        <div className={cn("h-full rounded-v25-full transition-[width] duration-300", fill)} style={{ width: `${pct}%` }} />
      </div>
      {label != null && (
        <span className={cn("min-w-[36px] whitespace-nowrap text-right text-[11px]", onDark ? "font-medium text-white" : "text-v25-ink-500")}>
          {label}
        </span>
      )}
    </div>
  );
}
